// Shared chip colors + short labels, used by both the table (SubmissionsDatabase)
// and the detail drawer so the two stay visually consistent. Muted, lower-chroma
// "dusty" fills with white text — a distinct hue per value (so topics stay
// individually identifiable) but toned down for IFP's restrained palette.

const WHITE = '#ffffff';

// High-level themes — the 16 "Topic" values (the primary signal on cards/filters).
// One muted hue each; subtopics (low-level) inherit a neutral chip (see below).
export const THEME_COLORS = {
  'experience-benchmarking': { bg: '#8a5570', fg: WHITE },        // mauve
  'misclassification': { bg: '#9a4f48', fg: WHITE },              // dusty brick
  'legal-concerns': { bg: '#4f5a6b', fg: WHITE },                 // slate
  'wage-gap-critiques': { bg: '#635a82', fg: WHITE },             // muted indigo
  'underpayment': { bg: '#9e5a3f', fg: WHITE },                   // clay
  'private-wage-surveys': { bg: '#46637f', fg: WHITE },           // steel blue
  'oews-accuracy': { bg: '#3f6f6a', fg: WHITE },                  // muted teal
  'sector-specific-impacts': { bg: '#4e7050', fg: WHITE },        // sage
  'impact-us-workers': { bg: '#6f6a3f', fg: WHITE },              // olive
  'base-compensation': { bg: '#7a6a5a', fg: WHITE },              // warm taupe
  'eb3': { bg: '#7a4d63', fg: WHITE },                            // dusty plum
  'early-career': { bg: '#a5663f', fg: WHITE },                   // terracotta
  'highly-specialized-workers': { bg: '#3f6f5a', fg: WHITE },     // teal-green
  'transition-period': { bg: '#57663f', fg: WHITE },             // moss
  'american-competitiveness': { bg: '#9a7b3f', fg: WHITE },       // ochre
  'regulatory-impact-analysis': { bg: '#5a6b7a', fg: WHITE },     // dusty blue-gray
  _default: { bg: '#6b7280', fg: WHITE },                         // gray
};
export const themeColor = id => THEME_COLORS[id] || THEME_COLORS._default;

// Concise 1-3 word chip labels for the Topic column (full name shown elsewhere).
export const THEME_SHORTHAND = {
  'experience-benchmarking': 'Experience benchmarking',
  'misclassification': 'Misclassification',
  'legal-concerns': 'Legal concerns',
  'wage-gap-critiques': 'Wage gap critiques',
  'underpayment': 'Underpayment',
  'private-wage-surveys': 'Private wage surveys',
  'oews-accuracy': 'OEWS accuracy',
  'sector-specific-impacts': 'Sector-specific',
  'impact-us-workers': 'US workers',
  'base-compensation': 'Base compensation',
  'eb3': 'EB-3',
  'early-career': 'Early career',
  'highly-specialized-workers': 'Highly specialized',
  'transition-period': 'Transition period',
  'american-competitiveness': 'Competitiveness',
  'regulatory-impact-analysis': 'Regulatory analysis',
};

// Low-level subtopics share a single neutral chip — there are only 7 and they
// always sit visually beneath their (colored) parent topic, so a distinct hue
// per subtopic would add noise rather than signal.
export const SUBTOPIC_COLOR = { bg: '#8b8f96', fg: WHITE };

// Recommendation categories — short chip label + a semantic color each.
export const ACTION_SHORTHAND = {
  'Finalize as written': 'Finalize',
  'Withdraw outright': 'Withdraw',
  'Explore Experience Benchmarking': 'Explore EB',
  'Finalize with modifications': 'Finalize+mods',
  'Address sector-specific concerns': 'Sector-specific',
  'Other recommendations': 'Other',
};
export const ACTION_COLORS = {
  'Finalize as written': { bg: '#4e7050', fg: WHITE },             // sage
  'Withdraw outright': { bg: '#9a4f48', fg: WHITE },               // dusty brick
  'Explore Experience Benchmarking': { bg: '#635a82', fg: WHITE }, // muted indigo
  'Finalize with modifications': { bg: '#46637f', fg: WHITE },     // steel blue
  'Address sector-specific concerns': { bg: '#3f6f6a', fg: WHITE },// muted teal
  'Other recommendations': { bg: '#6b7280', fg: WHITE },           // gray
};
export const actionColor = a => ACTION_COLORS[a] || ACTION_COLORS['Other recommendations'];

// Commenter type — a single consistent muted slate chip (too many types for distinct hues).
export const COMMENTER_COLOR = { bg: '#4f5a6b', fg: WHITE };
